import React from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import "mdb-ui-kit/css/mdb.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { Input, Ripple, initMDB } from "mdb-ui-kit";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useMediaQuery, useTheme } from "@mui/material";
import FooterManual from "./footerManual";
import Notes from "./header";

initMDB({ Input, Ripple, initMDB });

// Color Constants
const RED = "#DC2626";
const DARK_RED_ACCENT = "#991B1B";
const BLACK_TEXT = "#1F2937";
const GRAY_TEXT = "#4B5563";
const LIGHT_RED_BG = "#FEF2F2";

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
    ...theme.applyStyles("dark", {
        backgroundColor: "#1A2027",
    }),
}));

const Disclaimer = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
    const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));

    return (
        <Box
            className="container-main-AllSeeModels"
            sx={{
                position: "relative",
                width: "100%",
                minHeight: "100vh",
                backgroundColor: "#fff"
            }}
        >
            <Box sx={{ marginBottom: "0%" }}><Notes /></Box>

            {/* Banner Section */}
            <Box
                sx={{
                    position: "relative",
                    width: "100%",
                    height: isMobile ? "25vh" : isTablet ? "35vh" : "50vh",
                    backgroundColor: "black",
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: "hidden",
                }}
            >
                <Box
                    component="img"
                    src="/image/AllSeeModelsBackgroungCar.png"
                    alt="Automotive Background"
                    sx={{
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        opacity: 0.35,
                    }}
                />

                <Typography
                    sx={{
                        position: "relative",
                        color: "white",
                        fontWeight: "900",
                        textTransform: "uppercase",
                        letterSpacing: isMobile ? "1px" : isTablet ? "2px" : "4px",
                        fontSize: isMobile ? "24px" : isTablet ? "42px" : "60px",
                        zIndex: 2,
                        textShadow: "0 0 10px rgba(0,0,0,0.8)",
                        textAlign: "center",
                        lineHeight: 1.1,
                        px: "20px",
                    }}
                >
                    Disclaimer
                </Typography>
            </Box>

            {/* Main Content Container */}
            <Box
                sx={{
                    width: isMobile ? "95%" : isTablet ? "92%" : "85%",
                    backgroundColor: "#FFFFFF",
                    margin: "0 auto",
                    marginTop: isMobile ? "-50px" : isTablet ? "-60px" : "-80px",
                    borderRadius: isMobile ? "12px" : isTablet ? "16px" : "20px",
                    padding: isMobile ? "20px 16px" : isTablet ? "32px 24px" : "40px 30px",
                    boxShadow: "0 15px 50px rgba(0, 0, 0, 0.12)",
                    zIndex: 10,
                    position: "relative",
                }}
            >
                {/* Introduction Section */}
                <Box sx={{ textAlign: "center", marginBottom: isMobile ? "35px" : isTablet ? "45px" : "60px" }}>
                    <Typography
                        sx={{
                            fontWeight: "800",
                            color: DARK_RED_ACCENT,
                            marginBottom: isMobile ? "10px" : "12px",
                            textTransform: "uppercase",
                            fontSize: isMobile ? "18px" : isTablet ? "24px" : "32px",
                            lineHeight: 1.3,
                        }}
                    >
                        Legal Disclaimer & Website Terms
                    </Typography>
                    <Typography
                        sx={{
                            color: GRAY_TEXT,
                            fontSize: isMobile ? "13px" : isTablet ? "14px" : "16px",
                            maxWidth: "900px",
                            margin: "0 auto",
                            lineHeight: "1.7",
                            px: isMobile ? "12px" : "0",
                        }}
                    >
                        This disclaimer outlines the terms and conditions for the use of our website and services. Please read this document carefully to understand your rights and responsibilities when using <b>www.amar.co.jp</b>.
                    </Typography>
                </Box>

                {/* Disclaimer Content with Creative Styling */}
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: isMobile ? "15px" : "20px",
                    }}
                >
                    {/* Contact Information */}
                    <Box sx={{ 
                        padding: isMobile ? "15px" : "20px", 
                        borderLeft: `4px solid ${RED}`,
                        backgroundColor: LIGHT_RED_BG,
                        borderRadius: "0 8px 8px 0",
                        transition: "all 0.3s ease",
                        '&:hover': {
                            boxShadow: `0 4px 12px rgba(220, 38, 38, 0.2)`,
                            transform: "translateX(5px)",
                        }
                    }}>
                        <Typography sx={{ color: BLACK_TEXT, fontWeight: "600", marginBottom: "8px", fontSize: isMobile ? "14px" : "16px" }}>
                            <i className="fas fa-envelope" style={{ marginRight: "8px", color: RED }}></i>
                            Contact Information
                        </Typography>
                        <Typography sx={{ color: GRAY_TEXT, lineHeight: "1.6", fontSize: isMobile ? "13px" : "15px" }}>
                            If you require any more information or have any questions about our site's disclaimer, please feel free to contact us by email at <span style={{color: RED, fontWeight: "bold"}}>sales@amar.co.jp</span>.
                        </Typography>
                    </Box>

                    {/* Website Disclaimer */}
                    <Box sx={{ 
                        padding: isMobile ? "15px" : "20px", 
                        borderLeft: `4px solid ${DARK_RED_ACCENT}`,
                        backgroundColor: LIGHT_RED_BG,
                        borderRadius: "0 8px 8px 0",
                        transition: "all 0.3s ease",
                        '&:hover': {
                            boxShadow: `0 4px 12px rgba(220, 38, 38, 0.2)`,
                            transform: "translateX(5px)",
                        }
                    }}>
                        <Typography sx={{ color: BLACK_TEXT, fontWeight: "600", marginBottom: "8px", fontSize: isMobile ? "14px" : "16px" }}>
                            <i className="fas fa-globe" style={{ marginRight: "8px", color: RED }}></i>
                            Website Disclaimer
                        </Typography>
                        <Typography sx={{ color: GRAY_TEXT, lineHeight: "1.6", fontSize: isMobile ? "13px" : "15px" }}>
                            All the information on this website is published in good faith and for general information purpose only. <span style={{color: RED, fontWeight: "bold"}}>www.amar.co.jp</span> does not make any warranties about the completeness, reliability and accuracy of this information. Any action you take upon the information you find on this website is strictly at your own risk. www.amar.co.jp will not be liable for any losses and/or damages in connection with the use of our website.
                        </Typography>
                    </Box>

                    {/* External Links */}
                    <Box sx={{ 
                        padding: isMobile ? "15px" : "20px", 
                        borderLeft: `4px solid ${RED}`,
                        backgroundColor: LIGHT_RED_BG,
                        borderRadius: "0 8px 8px 0",
                        transition: "all 0.3s ease",
                        '&:hover': {
                            boxShadow: `0 4px 12px rgba(220, 38, 38, 0.2)`,
                            transform: "translateX(5px)",
                        }
                    }}>
                        <Typography sx={{ color: BLACK_TEXT, fontWeight: "600", marginBottom: "8px", fontSize: isMobile ? "14px" : "16px" }}>
                            <i className="fas fa-link" style={{ marginRight: "8px", color: RED }}></i>
                            External Links
                        </Typography>
                        <Typography sx={{ color: GRAY_TEXT, lineHeight: "1.6", fontSize: isMobile ? "13px" : "15px" }}>
                            From our website, you can visit other websites by following hyperlinks to such external sites. While we strive to provide only quality links to useful and ethical websites, we have no control over the content and nature of these sites. These links to other websites do not imply a recommendation for all the content found on these sites. Site owners and content may change without notice and may occur before we have the opportunity to remove a link which may have gone 'bad'.
                        </Typography>
                    </Box>

                    {/* Privacy & Terms */}
                    <Box sx={{ 
                        padding: isMobile ? "15px" : "20px", 
                        borderLeft: `4px solid ${DARK_RED_ACCENT}`,
                        backgroundColor: LIGHT_RED_BG,
                        borderRadius: "0 8px 8px 0",
                        transition: "all 0.3s ease",
                        '&:hover': {
                            boxShadow: `0 4px 12px rgba(220, 38, 38, 0.2)`,
                            transform: "translateX(5px)",
                        }
                    }}>
                        <Typography sx={{ color: BLACK_TEXT, fontWeight: "600", marginBottom: "8px", fontSize: isMobile ? "14px" : "16px" }}>
                            <i className="fas fa-lock" style={{ marginRight: "8px", color: RED }}></i>
                            Privacy & Terms
                        </Typography>
                        <Typography sx={{ color: GRAY_TEXT, lineHeight: "1.6", fontSize: isMobile ? "13px" : "15px" }}>
                            Please be also aware that when you leave our website, other sites may have different privacy policies and terms which are beyond our control. Please be sure to check the Privacy Policies of these sites as well as their "Terms of Service" before engaging in any business or uploading any information.
                        </Typography>
                    </Box>

                    {/* Consent */}
                    <Box sx={{ 
                        padding: isMobile ? "15px" : "20px", 
                        borderLeft: `4px solid ${RED}`,
                        backgroundColor: LIGHT_RED_BG,
                        borderRadius: "0 8px 8px 0",
                        transition: "all 0.3s ease",
                        '&:hover': {
                            boxShadow: `0 4px 12px rgba(220, 38, 38, 0.2)`,
                            transform: "translateX(5px)",
                        }
                    }}>
                        <Typography sx={{ color: BLACK_TEXT, fontWeight: "600", marginBottom: "8px", fontSize: isMobile ? "14px" : "16px" }}>
                            <i className="fas fa-check-circle" style={{ marginRight: "8px", color: RED }}></i>
                            Consent
                        </Typography>
                        <Typography sx={{ color: GRAY_TEXT, lineHeight: "1.6", fontSize: isMobile ? "13px" : "15px" }}>
                            By using our website, you hereby consent to our disclaimer and agree to its terms. Your continued use of this website signifies your acceptance of these terms and conditions.
                        </Typography>
                    </Box>

                    {/* Update */}
                    <Box sx={{ 
                        padding: isMobile ? "15px" : "20px", 
                        borderLeft: `4px solid ${DARK_RED_ACCENT}`,
                        backgroundColor: LIGHT_RED_BG,
                        borderRadius: "0 8px 8px 0",
                        transition: "all 0.3s ease",
                        '&:hover': {
                            boxShadow: `0 4px 12px rgba(220, 38, 38, 0.2)`,
                            transform: "translateX(5px)",
                        }
                    }}>
                        <Typography sx={{ color: BLACK_TEXT, fontWeight: "600", marginBottom: "8px", fontSize: isMobile ? "14px" : "16px" }}>
                            <i className="fas fa-sync-alt" style={{ marginRight: "8px", color: RED }}></i>
                            Updates to This Disclaimer
                        </Typography>
                        <Typography sx={{ color: GRAY_TEXT, lineHeight: "1.6", fontSize: isMobile ? "13px" : "15px" }}>
                            Should we update, amend or make any changes to this document, those changes will be prominently posted here. We encourage you to review this disclaimer periodically to stay informed of any updates.
                        </Typography>
                    </Box>
                </Box>

                {/* Important Notice Box */}
                <Box 
                    sx={{
                        marginTop: isMobile ? "30px" : isTablet ? "40px" : "50px",
                        padding: isMobile ? "15px" : "20px",
                        backgroundColor: LIGHT_RED_BG,
                        border: `2px solid ${RED}`,
                        borderRadius: isMobile ? "8px" : "12px",
                        textAlign: "center",
                    }}
                >
                    <Typography sx={{ color: RED, fontWeight: "700", fontSize: isMobile ? "16px" : "18px", marginBottom: "10px" }}>
                        <i className="fas fa-exclamation-circle" style={{ marginRight: "8px" }}></i>
                        Important Legal Notice
                    </Typography>
                    <Typography sx={{ color: BLACK_TEXT, fontSize: isMobile ? "13px" : "15px", lineHeight: "1.6" }}>
                        This disclaimer is governed by the laws of Japan. If any portion of this disclaimer is deemed unenforceable, the remaining portions shall continue to be in full force and effect. For any legal matters or disputes, please refer to our full Terms and Conditions.
                    </Typography>
                </Box>
            </Box>

            {/* Space Filler for Footer Alignment */}
            <Box sx={{ height: isMobile ? "10px" : isTablet ? "10px" : "50px" }} />

            <FooterManual />
        </Box>
    );
};

export default Disclaimer;